import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { useLanguage } from '../hooks/useLanguage';
import { TranslationKey } from '../i18n/translations';

const navItems: { path: string; labelKey: TranslationKey }[] = [
  { path: '/', labelKey: 'nav_home' },
  { path: '/tasks', labelKey: 'nav_tasks' },
  { path: '/leaderboard', labelKey: 'nav_top' },
  { path: '/profile', labelKey: 'nav_profile' },
];

export function Navigation() {
  const { t } = useLanguage();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-tg border-t border-tg-hint/20 pb-[env(safe-area-inset-bottom)]">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              clsx(
                'flex flex-col items-center justify-center w-16 h-full',
                'transition-colors duration-200',
                isActive ? 'text-brand-primary font-semibold' : 'text-tg-hint'
              )
            }
          >
            <span className="text-sm font-medium">{t(item.labelKey)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
